// Moved to components/ds/DsHeader.js (shared with Receiving).
export { default } from "@components/ds/DsHeader";
